import {
  ADD_COMPARISON_PLAN,
  REMOVE_COMPARISON_PLAN,
  CLEAN_COMPARISON_PLANS,
  FETCH_PLANS,
  FETCH_CATEGORIES,
  FILTER_PLANS,
  UNSELECT_FILTER_CATEGORY_OPTIONS,
  SET_SORT_OPTION,
  SET_PROVIDER_OPTION,
  SET_QUOTATION_PARAMS,
  FILTER_PLANS_MOBILE,
  OPEN_MODAL_QUOTATION_DATE_WARNING,
  CLOSE_MODAL_QUOTATION_DATE_WARNING,
  OPEN_MODAL_FILTER_CATEGORY,
  CLOSE_MODAL_FILTER_CATEGORY,
  GET_INFOS_PROSPECT,
  OPEN_MODAL_QUOTATION_DATE_YEAR,
  CLOSE_MODAL_QUOTATION_DATE_YEAR,
  OPEN_MODAL_WITHOUT_TRACKER,
  CLOSE_MODAL_WITHOUT_TRACKER,
  SET_TRACKER_INFOS_PROSPECT,
  TRACKER_MODAL_VALIDATOR_HANDLER_BLUR,
  VALIDATE_TRACKER_MODAL_REDIRECT,
  APPLY_FILTER_CATEGORIES,
  CLEAR_FILTER_CATEGORIES,
  SEARCH_ECOMMERCE_SETTINGS,
  SEARCH_PROVIDER_SETTINGS,
  SET_SORT_OPTIONS,
  TOGGLE_SPECIALIST_SUGGESTION,
  STORE_HIGHLIGTH_PLANS,
  OPEN_MODAL_UPSELL,
  CLOSE_MODAL_UPSELL,
  SET_UPSELL_PLANS,
  SET_UPSELL_SOURCE_TAGS,
} from './actionTypes';

import { getProductQuotation } from '../apiCalls';

export const searchEcommerceSettings = (settings) => ({
  type: SEARCH_ECOMMERCE_SETTINGS,
  settings,
});

export const searchProviderSettings = (settings) => ({
  type: SEARCH_PROVIDER_SETTINGS,
  settings,
});

export const addComparisonPlan = (plan) => ({
  type: ADD_COMPARISON_PLAN,
  plan,
});

export const removeComparisonPlan = (planCode) => ({
  type: REMOVE_COMPARISON_PLAN,
  planCode,
});

export const cleanComparisonPlans = () => ({
  type: CLEAN_COMPARISON_PLANS,
});

export const fetchPlans = (plans, context) => ({
  type: FETCH_PLANS,
  context,
  plans,
});

export const fetchCategories = (category, params) => ({
  type: FETCH_CATEGORIES,
  category,
  params,
});

export const filterPlans = () => ({
  type: FILTER_PLANS,
});

export const unselectFilterCategoryOptions = (type_category, category_index, option_index = 0) => ({
  type: UNSELECT_FILTER_CATEGORY_OPTIONS,
  type_category,
  category_index,
  option_index,
});

export const applyFilterCategories = (selected_category) => ({
  type: APPLY_FILTER_CATEGORIES,
  selected_category,
});

export const clearFilterCategories = () => ({
  type: CLEAR_FILTER_CATEGORIES,
});

export const setSortOptions = (sortOptions) => ({
  type: SET_SORT_OPTIONS,
  sortOptions,
});

export const setSortOption = (sort_option) => ({
  type: SET_SORT_OPTION,
  sort_option,
});

export const setProviderFilter = (provider_option) => ({
  type: SET_PROVIDER_OPTION,
  provider_option,
});

export const filterPlansMobile = () => ({
  type: FILTER_PLANS_MOBILE,
});

export const openModalQuotationDateWarning = () => ({
  type: OPEN_MODAL_QUOTATION_DATE_WARNING,
});

export const closeModalQuotationDateWarning = () => ({
  type: CLOSE_MODAL_QUOTATION_DATE_WARNING,
});

export const setInfosProspect = (infos) => ({
  type: GET_INFOS_PROSPECT,
  infos,
});

export const openModalQuotationDateYear = () => ({
  type: OPEN_MODAL_QUOTATION_DATE_YEAR,
});

export const closeModalQuotationDateYear = () => ({
  type: CLOSE_MODAL_QUOTATION_DATE_YEAR,
});

export const setQuotationParams = ({ begin_date, end_date, destination, product_code, context, benefits, queryParams }) => {
  getProductQuotation({
    begin_date,
    end_date,
    destination,
    product_code,
    context,
    benefits,
  });

  return {
    type: SET_QUOTATION_PARAMS,
    begin_date,
    end_date,
    destination,
    queryParams
  };
};

export const openModalWithoutTracker = () => ({
  type: OPEN_MODAL_WITHOUT_TRACKER,
});

export const closeModalWithoutTracker = () => ({
  type: CLOSE_MODAL_WITHOUT_TRACKER,
});

export const openModalFilterCategory = () => ({
  type: OPEN_MODAL_FILTER_CATEGORY,
});

export const closeModalFilterCategory = () => ({
  type: CLOSE_MODAL_FILTER_CATEGORY,
});

export const setInfosModalProspect = (prospect) => ({
  type: SET_TRACKER_INFOS_PROSPECT,
  prospect,
});

export const trackerModalValidatorHandlerBlur = (key) => ({
  type: TRACKER_MODAL_VALIDATOR_HANDLER_BLUR,
  key,
});

export const validateTrackerModalRedirect = (destination, begin_date, end_date, couponModal) => ({
  type: VALIDATE_TRACKER_MODAL_REDIRECT,
  destination,
  begin_date,
  end_date,
  couponModal,
});

export const storeHighligthPlans = (plans) => ({
    type: STORE_HIGHLIGTH_PLANS,
    plans,
  })


export const toggleSpecialistSuggestion = () => ({
  type: TOGGLE_SPECIALIST_SUGGESTION,
});

export const openModalUpsell = () => ({
    type: OPEN_MODAL_UPSELL,
})

export const closeModalUpsell = () => ({
    type: CLOSE_MODAL_UPSELL,
})

export const setUpsellPlans = (plans) => ({
    type: SET_UPSELL_PLANS,
    plans,
})

export const setUpsellSourceTags = (tags) => ({
    type: SET_UPSELL_SOURCE_TAGS,
    tags,
})


// WEBPACK FOOTER //
// ./src/actions/searchActions.js